import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import AboutHero from "./components/AboutHero";
import MissionVision from "./components/MissionVision";
import StorySection from "./components/StorySection";
import LeadershipSection from "./components/LeadershipSection";
import ValuesSection from "./components/ValuesSection";
import WhatWeDo from "./components/WhatWeDo";
import WhyChooseSection from "./components/WhyChooseSection";
import AboutCTA from "./components/AboutCTA";
import { usePageMeta } from "../../hooks/usePageMeta";

/** Set to true to show the leadership cards and full-profile modal again. */
const SHOW_LEADERSHIP = false;

export default function AboutPage() {
  usePageMeta(
    "About Us | StackMap Systems",
    "Learn about StackMap's mission, leadership team, values, and the story behind our operational infrastructure platform."
  );

  return (
    <div className="min-h-screen bg-graphite-900">
      <Navbar />
      <main>
        <AboutHero />
        <MissionVision />
        <StorySection />
        {SHOW_LEADERSHIP && <LeadershipSection />}
        <ValuesSection />
        <WhatWeDo />
        <WhyChooseSection />
        <AboutCTA />
      </main>
      <Footer />
    </div>
  );
}
